// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { fetchOlderNotifications } from '../../../../../notifications/notificationActions';

// Components
import Button from '../../../../../components/buttons/Button';
import Spinner from '../../../../../components/loaders/Spinner';

// Styles
import './NotificationShowMoreButton.scss';

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchOlderNotifications: () => dispatch(fetchOlderNotifications()),
});

class NotificationShowMoreButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };

        this.isComponentMounted = true;
    }

    componentWillUnmount() {
        this.isComponentMounted = false;
    }

    fetchOlderNotifications = () => {
        const { dispatchFetchOlderNotifications } = this.props;

        this.setState({ loading: true });

        return dispatchFetchOlderNotifications().then((_) => {
            if (!this.isComponentMounted) return;

            this.setState({ loading: false });
        });
    };

    render() {
        const { loading } = this.state;
        const { hasMore } = this.props;

        if (!hasMore) return null;

        return (
            <li className="NotificationShowMoreButton">
                {loading ? <Spinner show /> : <Button onClick={this.fetchOlderNotifications}>Load more</Button>}
            </li>
        );
    }
}

NotificationShowMoreButton.propTypes = {
    hasMore: PropTypes.bool,
    dispatchFetchOlderNotifications: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(NotificationShowMoreButton);
